import { useCallback } from 'react'

import useAppDispatch from '../../../store/hooks/useAppDispatch'
import useAppStore from '../../../store/hooks/useAppStore'
import localStorageUtils from '../../app/utils/localStorageUtils'
import { LocalStorageCartMeta } from '../../checkout/types'
import {
  clientContextCustomerEmailSelector,
  clientContextCustomerNameSelector,
} from '../../clientContext/store/clientContextSelectors'
import {
  preOrderCreatedGroupOrderIdSelector,
  preOrderUpcomingOrderByIdSelector,
} from '../store/preOrderSelectors'
import { setPreOrderUser } from '../store/preOrderSlice'
import storedPreOrderUserToken from '../utils/storedPreOrderUserToken'

/**
 * Makes the just created group order the current cart, with the company user
 * as its host, so the host can add food or manage the members. Returns the
 * created order, or null when it can't be found.
 */
export default function useStartGroupOrderHostSession() {
  const dispatch = useAppDispatch()
  const store = useAppStore()

  return useCallback(() => {
    const state = store.getState()
    const createdGroupOrderId = preOrderCreatedGroupOrderIdSelector(state)
    const createdGroupOrder = createdGroupOrderId
      ? preOrderUpcomingOrderByIdSelector(state, createdGroupOrderId)
      : undefined

    if (!createdGroupOrderId || !createdGroupOrder) {
      return null
    }

    const { outlet, hostAttendeeId } = createdGroupOrder

    localStorageUtils.setItem<LocalStorageCartMeta>('cartMeta', {
      outletId: outlet.id,
      checkoutId: createdGroupOrderId,
      isPreOrderCheckout: true,
    })

    if (hostAttendeeId) {
      const preOrderUser = {
        id: hostAttendeeId,
        name: clientContextCustomerNameSelector(state)!,
        email: clientContextCustomerEmailSelector(state)!,
        isHost: true,
      }

      storedPreOrderUserToken.create(preOrderUser)
      dispatch(setPreOrderUser(preOrderUser))
    }

    return createdGroupOrder
  }, [dispatch, store])
}
